// extracted by mini-css-extract-plugin
export default {"page":"TermsOfUse_page__68YtT","content":"TermsOfUse_content__sAZGS","title":"TermsOfUse_title__+vKh8","links":"TermsOfUse_links__0BY3m","section":"TermsOfUse_section__ulK3o"};